import React, { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import "./revenue.css";
import { COMPANY_LOGO_BASE_URL } from "../../../config/apiConfig";

function GrowthPill({ pct=0 }) {
  const cls = pct > 0 ? "pos" : pct < 0 ? "neg" : "";
  const sign = pct > 0 ? "+" : "";
  return <span className={`rt-pill ${cls}`}>{`${sign}${pct}%`} Avg Growth</span>;
}

export default function CompanyHeader({ company, context, profileTo }) {
  const hasGrowth =
    context?.avgGrowthPct !== null &&
    context?.avgGrowthPct !== undefined &&
    context?.avgGrowthPct !== "" &&
    context?.avgGrowthPct !== 0 &&
    context?.defaultValue;

  const fallbackLogo = "/img/company_images/default_Company_logo.png";

  const computedLogoUrl = useMemo(() => {
    const name = company?.name?.trim();
    return name ? `${COMPANY_LOGO_BASE_URL}${encodeURIComponent(name)}` : fallbackLogo;
  }, [company?.name]);

  // Allow graceful fallback if the remote logo 404s
  const [logoSrc, setLogoSrc] = useState(computedLogoUrl);
  return (
    <div className="rt-company d-flex justify-content-between align-items-center">
      <div className="d-flex align-items-center gap-3">
        {/* {company?.logo ? (
          <img src={company.logo} alt={""} width="42" height="42" className="rt-logo" />
        ) : <img src={`/img/company_images/default_Company_logo.png`} alt="" width="42" height="42" className="rt-logo" />} */}
        <img
          src={logoSrc}
          alt={company?.name || "Company logo"}
          width="40"
          height="40"
          className="rt-logo"
          onError={() => setLogoSrc(fallbackLogo)}
        />
        <div>
          <div className="rt-comp-title">
            {company?.name}{" "}
            <span className="rt-comp-note">
              (Multi-Dimensional Revenue Explorer – {context?.fiscalYear})
            </span>
          </div>
          <div className="d-flex align-items-center gap-2">
             <h3 className="mb-0 rt-total" title={
             context?.totalRevenueRange
               ? `Reported: ${context.totalRevenueReported} • Modeled: ${context.totalRevenueModeled}`
               : undefined
           }>
             {context?.totalRevenue}
           </h3>
            {hasGrowth && <GrowthPill pct={context?.avgGrowthPct} />}
          </div>
        </div>
      </div>
      {profileTo && (
       <Link to={profileTo} className="view_profile_Revenue">
         View Profile
       </Link>
     )}
    </div>
  );
}
